import { Ratings } from "@/api/AppApi/services/home/interfaces/IProduct";
import { atom } from "jotai";

export type ProductReviewAtomProps = {
  product_id: number | string;
  rate: number;
  ratings: Ratings;
  canReview: boolean;
};
export interface SubmitProductReviewAtomProps {
  product_id: number | string;
  initialValues?: {
    review_id?: number;
    rating?: number;
    comment?: string;
    attachments?: string[];
  };
}
export type ProductPopupAtom = {
  productID: string | number;
  cartItemID?: number;
  AttrbuitesInitialValues?: number[];
  isConfigurable?: boolean;
};
export type PopupValue =
  | string
  | number
  | true
  | ProductReviewAtomProps
  | SubmitProductReviewAtomProps
  | ProductPopupAtom;
function creatPopupAtoms<TValue extends PopupValue>(
  initialValue: TValue | null,
) {
  const baseAtom = atom(initialValue);
  const valueAtom = atom((get) => get(baseAtom));
  const openAtom = atom(null, (_, set, value: TValue) => {
    set(baseAtom, value);
  });
  const closeAtom = atom(null, (_, set) => set(baseAtom, null));

  return {
    valueAtom,
    openAtom,
    closeAtom,
  };
}

export default creatPopupAtoms;
